import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/** What the status icon reports; each tone has its own colour pair (theme `$status-icon-*` tokens) */
export enum StatusIconTone {
  Done = 'done',
  InProgress = 'in-progress',
  Success = 'success',
  Neutral = 'neutral',
  /** the warning card's colours: the orange "Same as last time" mark (#4142 review fixes) */
  Warning = 'warning',
  /** the assertive card's colours: the red "Fewer reps" mark (#4142 review fixes) */
  Assertive = 'assertive',
}

export enum StatusIconSize {
  // a card's own status: the home page daily items, an exercise card, the workout summary heading
  Large = 'large',
  // a row's status inside a card: a set row, a workout summary row
  Small = 'small',
}

/**
 * The one status icon of the home page and the workout page: an icon on a dark circle of its
 * colour, as the info cards draw theirs. Every status circle uses this component, so a style
 * change here applies everywhere at once. Unlike cs-icon, a caller may add its own `class`
 * (e.g. a layout hook): Angular keeps it alongside the tone and size classes bound here.
 */
@Component({
  selector: 'cs-status-icon',
  templateUrl: 'cs-status-icon.html',
  host: { 'class': 'status-icon' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsStatusIconComponent {
  @Input() tone: StatusIconTone = StatusIconTone.Neutral;
  @Input() size: StatusIconSize = StatusIconSize.Large;
  @Input() icon = 'checkmark-circle';
  /** colour the icon with the card's text colour instead of its icon colour; no effect on Neutral */
  @Input() textIcon = false;

  // the tone and size classes the stylesheet keys on
  @HostBinding('class')
  get hostClasses(): string {
    return `tone-${this.tone} size-${this.size}` + (this.textIcon ? ' text-icon' : '');
  }
}
